'use strict';

module.exports = {
    SIGNIANT_SERVICE_NOT_FOUND: 'signiant.service.not.found',
    PORTAL_EXPIRED: 'portal.expired',
    PORTAL_NEAR_EXPIRATION: 'portal.near.expiration',
    STORAGE_NOT_ASSIGNED: 'storage.not.assigned',
    STORAGE_NOT_AVAILABLE: 'storage.not.available',
    STORAGE_REACHED_FULL_CAPACITY: 'storage.reached.full.capacity',
    STORAGE_NEAR_FULL_CAPACITY: 'storage.near.full.capacity'
};